import { Reducer,  Action } from "redux";
import { KnownAuthStateActionsType, unloadedAuthState, AuthSettingsState } from "./index";
import {iAuthenticationState} from '../../lib/Interfaces/Authentication'



//Reducer - For a given state and action, returns the new state. This does not mutate old state, simply creates a new one

export const reducer: Reducer<AuthSettingsState> = (state: AuthSettingsState | undefined, incomingAction : Action): AuthSettingsState => {
    if (state === undefined) {
        return unloadedAuthState;
    }

    const action = incomingAction as KnownAuthStateActionsType;
    
    //outdated, don't use switches anymore
    switch (action.type)  {
        case "SET_AUTH_STATE_AFTER_POST_LOGIN":
            return {
                authSettings: action.authSettings,
            } 
        case "CLEAR_AUTH_STATE_ON_LOGOUT":
            return {
                authSettings: unloadedAuthState.authSettings
            }
    }
    return state;
}